export default Object.freeze({
  drawerListItemIcon: "#8E92BC",
  drawerListItemIconSelected: "#141522",
  drawerListItemContainer: "#FFFFFF",
  drawerListItemContainerSelected: "#F5F5F7",
  mainContentBackgroundColor: "#FAFAFA",
  primary: "#141522",
  loginModalShape: "#FFFFFF15",
  loginTextFieldBackground: "#FFFFFFAA",
  loginTextFieldText: "#54577A",
  secondary: "#546FFF",
  transparentOverlay: "#000000AA",
  error: "#D32F2F",
  snackbarTextColor: "#FFFFFF",
  success: "#2E7D32",
  primaryText: "#141522",
  emergencyRequestCardBackground: "#fffeca",
});
